import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useCallback, useEffect, useState } from "react";

import Api from "../api";

import { logoutAuth } from "./auth";

// export function CheckLogin() {
//     Api.defaults.headers.common["Authorization"] = `Bearer ${auth.access_token}`;
//     Api.get("/auth/myaccount")
//         .then((response) => {
//             const data = response.data;
//             if (auth?.auth_data?.email === data?.email) {
//                 setAuthData(auth);
//             } else {
//                 authLogout();
//             }
//         })
//         .catch((err) => {
//             const data = err.response;
//             if (data?.status === 401) {
//                 authLogout();
//             }
//         });
// }

export function useAuth() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state) => state.auth);
    const [authData, setAuthData] = useState(auth ? auth : null);

    const authLogout = useCallback(() => {
        dispatch(logoutAuth());
    }, [dispatch]);

    const checkLogin = useCallback(
        (auth) => {
            Api.defaults.headers.common["Authorization"] = `Bearer ${auth.access_token}`;
            Api.get("/auth/myaccount")
                .then((response) => {
                    const data = response.data;
                    if (auth?.auth_data?.email === data?.email) {
                        setAuthData(auth);
                    } else {
                        authLogout();
                    }
                })
                .catch((err) => {
                    const data = err.response;
                    if (data?.status === 401) {
                        authLogout();
                    }
                });
        },
        [setAuthData, authLogout],
    );

    useEffect(() => {
        if (auth) {
            checkLogin(auth);
        } else {
            setAuthData(auth);
        }
    }, [auth, checkLogin]);

    return authData;
}
